/***Dependencies */
import React, { useEffect, useState, useRef } from "react";
import { elementoPorSeccion } from "../services/adminProductService";

/**Components */
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { SearchEngine } from "./SearchEngine";

/**Images */

/**Styles */
import "../styles/index.scss";

/**
 * Componente principal que muestra el banner con carrusel, inputs de búsqueda y selector de habitaciones.
 * @param {array} imgsBanner - Arreglo de objetos con propiedades "image" que contienen la ruta de
 *                              las imágenes del carrusel.
 * @param {boolean} showSearch - Indica si se muestra el formulario de búsqueda o no.
 * @returns {React.Component} - Componente principal con el banner y los inputs de búsqueda.
 */
export const PrincipalBanner = ({ imgsBanner, showSearch, idElemento }) => {
  const [imgsBanners, setImgsBanners] = useState([]);
  const swiperRef = useRef(null);

  // 1. Lógica para obtener el elemento por sección
  useEffect(() => {
    const fetchElemento = async () => {
      try {
        const response = await elementoPorSeccion(idElemento);

        const formattedImages = response[0].imagenes.map((img) => ({
          image: img.url,
        }));

        setImgsBanners(formattedImages);
      } catch (err) {
        console.error("Error al cargar las imágenes:", err);
      }
    };

    fetchElemento();
  }, [idElemento]);

  useEffect(() => {
    const interval = setTimeout(() => {
      if (swiperRef.current?.swiper) {
        swiperRef.current.swiper.autoplay.start();
      }
    }, 500); // Esperar 500ms para asegurar la inicialización

    return () => clearTimeout(interval);
  }, []);

  return (
    <>
      <div className="banner-principal">
        {/* Carrusel */}
        <Swiper
          spaceBetween={30}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          loop={true}
          modules={[Autoplay]}
          className="mySwiper"
        >
          {imgsBanners.map((slide, index) => (
            <SwiperSlide key={index}>
              <img
                src={`https://panel.internationaltravelnet.com.mx/assets/uploads/elementos/${slide.image}`}
                alt={`Slide ${index + 1}`}
                className="banner-principal__img"
              />
            </SwiperSlide>
          ))}
        </Swiper>
        {/* Inputs Searchs */}
        {showSearch && <SearchEngine totalRooms={[]} destination={""} />}
      </div>
    </>
  );
};
